import { useTranslation } from 'react-i18next';
import { FallbackError, HrefLink, SingleLineText } from '@bloomays-lib/ui.shared';
import { TitlePart } from '@bloomays-lib/ui.shared';
import { styled } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import TableLegalContracts from '../organisms/TableLegalContracts';
import { useQuery } from '@apollo/client';
import { ContractsByMissionGQL, GetLegalContractsByMissionGQLResult } from '@bloomays-lib/types.shared';
import { GET_LEGAL_CONTRACTS_BY_MISSION } from '@bloomays-lib/adapter.api-bloomer';
import { LoaderPending } from '@bloomays-lib/ui.shared';

const MissionContracts = ({ play = true }: { play?: boolean }) => {
  const { t } = useTranslation(['legalContracts']);
  const { id } = useParams<{ id: string }>();
  const missionId = id as string;

  const {
    data: fetchContractsResult,
    loading: fetchingContracts,
    error: errorFetchingContracts,
  } = useQuery<GetLegalContractsByMissionGQLResult>(GET_LEGAL_CONTRACTS_BY_MISSION, {
    variables: { missionId },
  });

  if (fetchingContracts)
    return (<LoaderPending text={t('fetchingMissionContracts')} rotate={play} />) as React.ReactNode;
  if (errorFetchingContracts)
    return (<FallbackError errorText={t('errorFetchingContracts')}></FallbackError>) as React.ReactNode;
  if (!fetchContractsResult) return (<>{t('missionNotFound')}</>) as React.ReactNode;

  const contractsByMission: ContractsByMissionGQL = fetchContractsResult.getLegalContractsByMission;
  const mission = contractsByMission.mission;

  const missionText = t('pageSubTitle', {
    label: mission.label as string,
    societyName: mission.clientSocietyName,
  });

  return (
    <Container>
      <TitlePart id="titleAdminDashboard" span={t('pageTitle')} />
      <CenteredLinkContainer>
        <HrefLink href={`/missions/${missionId}`} target="_self">
          <SingleLineText variant={'body1Regular'} text={missionText} />
        </HrefLink>
      </CenteredLinkContainer>
      <TableContainer>
        <TableLegalContracts missionsContracts={[contractsByMission]} />
      </TableContainer>
    </Container>
  ) as React.ReactNode;
};

export default MissionContracts;

const Container = styled('div')(() => ({
  margin: '0 80px',
}));

const CenteredLinkContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '20px',
  marginBottom: '20px',
}));

const TableContainer = styled('div')(() => ({
  marginTop: '50px',
}));
